import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import ProductShowcaseForm from './ProductShowcaseForm';

const ProductShowcaseManager = ({ sectionId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null); 
  
  // Controle da Aba Ativa (Começa no Banner)
  const [activeTab, setActiveTab] = useState('banner_principal');

  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3030';

  const tabs = [
    { id: 'banner_principal', label: 'Banner Topo' },
    { id: 'galeria_horizontal', label: 'Galeria 1 (1:1)' },
    { id: 'amenidade', label: 'Amenidades' },
    { id: 'galeria_vertical', label: 'Galeria 2 (9:16)' },
    { id: 'planta', label: 'Plantas (Abas)' },
    { id: 'destaque', label: 'Destaques' }
  ];

  const fetchItems = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get(`/admin/sections/${sectionId}/items`);
      setItems(res.data || []);
    } catch (err) {
      console.error("Erro ao carregar itens de benefícios:", err);
    } finally {
      setLoading(false);
    }
  }, [sectionId]);

  useEffect(() => {
    if (sectionId) fetchItems();
  }, [sectionId, fetchItems]);

  const handleDelete = async (itemId) => {
    if (window.confirm("Tem certeza que deseja remover este item?")) {
      try {
        setLoading(true);
        await api.delete(`/admin/items/${itemId}`);
        fetchItems(); 
      } catch (err) {
        alert("Erro ao deletar item.");
        setLoading(false);
      }
    }
  };

  const handleAddNew = () => {
    // Nova lógica de contagem inteligente para as Plantas
    if (activeTab === 'planta') {
      const countImages = currentTabItems.filter(i => !i.is_intro).length;
      const hasIntro = currentTabItems.some(i => i.is_intro);
      
      if (countImages >= 4 && hasIntro) {
        return alert("O Bloco de Plantas já possui 4 imagens e 1 título. Edite os existentes.");
      }
      if (countImages >= 4 && !hasIntro) {
        alert("Atenção: Você já atingiu o limite de 4 imagens. Este novo item DEVE ser salvo com a opção 'Título/Introdução' marcada!");
      }
    }

    if (activeTab === 'banner_principal' && currentTabItems.length >= 1) {
      return alert("Você já possui um Banner Principal. Edite o existente ou exclua-o para criar um novo.");
    }
    setEditingItem(null);
    setShowForm(true);
  };

  if (showForm) {
    return (
      <ProductShowcaseForm
        sectionId={sectionId} 
        itemToEdit={editingItem}
        defaultCategory={activeTab} // Força o form a abrir na categoria da aba
        onSuccess={() => {
          setShowForm(false);
          setEditingItem(null);
          fetchItems();
        }} 
        onCancel={() => {
            setShowForm(false);
            setEditingItem(null);
        }}
      />
    );
  }

  // Filtra os itens para mostrar apenas os da aba selecionada
  const currentTabItems = items.filter(item => item.category === activeTab).sort((a,b) => a.item_order - b.item_order);

  console.log("ITENS QUE CHEGARAM DA API:", currentTabItems);

  return (
    <div>
      {/* NAVEGAÇÃO DAS ABAS (Com scroll horizontal para não quebrar em telas pequenas) */}
      <ul className="nav nav-tabs nav-fill mb-4">
        {tabs.map(tab => (
          <li className="nav-item" key={tab.id}>
            <button 
              className={`nav-link fw-bold ${activeTab === tab.id ? 'active text-primary bg-light border-bottom-0' : 'text-muted'}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {/* CABEÇALHO DO BLOCO DA ABA ATIVA */}
      <div className="d-flex justify-content-between align-items-center mb-3 bg-light p-3 border rounded">
        <div>
          <h6 className="fw-bold mb-0">Itens Cadastrados</h6>
          <small className="text-muted">Gerenciando: {tabs.find(t => t.id === activeTab)?.label}</small>
        </div>
        
        {/* Lógica restritiva para Banner e Plantas */}
        {activeTab === 'planta' && currentTabItems.filter(i => !i.is_intro).length >= 4 && currentTabItems.some(i => i.is_intro) ? (
           <span className="badge bg-warning text-dark p-2">Limite de Plantas Atingido</span>
        ) : activeTab === 'banner_principal' && currentTabItems.length >= 1 ? (
           <span className="badge bg-secondary p-2">Banner Cadastrado</span>
        ) : (
          <button className="btn btn-sm btn-success fw-bold px-3" onClick={handleAddNew}>
            <i className="bi bi-plus-lg me-1"></i> ADICIONAR ITEM AQUI
          </button>
        )}
      </div>

      {/* LISTAGEM DOS ITENS DA ABA */}
      {loading ? (
         <div className="text-center p-4">Carregando...</div>
      ) : (
        <div className="list-group">
          {currentTabItems.length === 0 ? (
            <div className="list-group-item text-center text-muted py-5 border-dashed">
              Nenhum item nesta aba.
            </div>
          ) : (
            currentTabItems.map(item => (
              <div key={item.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3">
                <div className="d-flex align-items-center gap-3">
                  
                  {/* PREVIEW DA IMAGEM / ÍCONE (Agora Universal) */}
                  <div style={{ width: '50px', textAlign: 'center' }}>
                    {item.images && item.images.length > 0 ? (
                      <img 
                        src={`${backendUrl}${item.images[0].image_url}`} 
                        alt="Thumb" 
                        className="rounded shadow-sm"
                        /* Alterado para 'contain' para não cortar ícones PNG transparentes */
                        style={{ height: '40px', width: '40px', objectFit: 'contain', backgroundColor: '#f8f9fa' }} 
                      />
                    ) : (
                      <i className="bi bi-image text-muted fs-3"></i>
                    )}
                  </div>

                  <div>
                    {item.is_intro ? (
                       <span className="badge bg-warning text-dark mb-1">Título/Introdução</span>
                    ) : (
                       <span className="badge bg-dark mb-1">Ordem: {item.item_order}</span>
                    )}
                    <h6 className="mb-0 fw-bold">{item.title}</h6>
                    {item.description && <small className="text-muted d-block text-truncate" style={{maxWidth: '300px'}}>{item.description}</small>}
                  </div>
                </div>

                <div className="btn-group shadow-sm">
                  <button 
                      className="btn btn-sm btn-outline-primary px-3" 
                      onClick={() => {
                          setEditingItem(item);
                          setShowForm(true);
                      }}>
                      <i className="bi bi-pencil"></i>
                  </button>
                  <button className="btn btn-sm btn-outline-danger px-3" onClick={() => handleDelete(item.id)}>
                    <i className="bi bi-trash"></i>
                  </button>
                </div>

              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ProductShowcaseManager;